import React from "react";
import { isEqual } from "lodash/lang";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import { withMapContext } from "./MapContext";
import appConstants from "../../../../appConstants";

class Marker extends React.Component {
  marker = null;
  markerRef = React.createRef();

  componentDidMount() {
    this.renderMarker();
  }

  hasChanged = (newProps) => {
    const positionChanged = !isEqual(this.props.position, newProps.position);
    let changed = false
    if (
       this.props.map !== newProps.map ||
       positionChanged ||
       this.props.data !== newProps.data ||
       this.props.zIndex !== newProps.zIndex ||
       this.props.draggable !== newProps.draggable ||
       this.props.applyOffset !== newProps.applyOffset
     ) {
        changed = true; 
     }
    return ({
      changed,
      positionChanged
    })
  }

  shouldComponentUpdate(nextProps, _nextState) {
    return this.hasChanged(nextProps).changed
  }

  componentDidUpdate(prevProps) {
     const changes = this.hasChanged(prevProps);
     if(changes.changed){
     this.renderMarker(changes.positionChanged);
     }   
  }

  renderMarker = (rePosition = false) => {
    const { map } = this.props;
    if (map) {
      if (!this.marker) {
        this.markerRef.current.addEventListener('click', this.handleMarkerClick, true);
        this.markerRef.current.addEventListener(
          'mouseover',
          this.onMouseHover,
          true
        );
        this.markerRef.current.addEventListener('mouseout', this.onMouseOut, true);
        this.marker = new TrimbleMaps.Marker({
          element: this.markerRef.current,
          draggable: this.props.draggable,
        })
          .setLngLat(this.props.position)
          .addTo(this.props.map);
        this.marker.on("dragstart", this.onDragStart);
        this.marker.on("drag", this.onDrag);
        this.marker.on("dragend", this.onDragEnd);
      } else if (this.props.forceUpdate || rePosition) {
        this.marker.setLngLat(this.props.position);
      }
      this.marker.setDraggable(this.props.draggable);

      if (this.props.isActiveShipment) {
        this.props.easeToAnimation
          ? map.easeTo({
              center: this.props.position,
              zoom: this.props.mapZoomLevel
            })
          : map.flyTo({
              center: this.props.position,
              offset: this.props.applyOffset ? this.props.offsetValue : [0, 0],
            });
        this.props.onAnimationDone?.();
      }
    }
  };

  componentWillUnmount() {
    if (this.markerRef.current) {
      this.markerRef.current.removeEventListener("click", this.handleMarkerClick, true);
      this.markerRef.current.removeEventListener("mouseover", this.onMouseHover, true);
      this.markerRef.current.removeEventListener("mouseout", this.onMouseOut, true);
    }
    if (this.marker) {
      this.marker.off("dragstart", this.onDragStart);
      this.marker.off("drag", this.onDrag);
      this.marker.off("dragend", this.onDragEnd);
      this.marker.remove();
      this.marker = null;
    }
  }

  handleMarkerClick = (event) => {
    event.stopPropagation();
    this.onClickHandler(event);
  };

  onClickHandler = (event) => {
    if (this.props.onClick) {
      const eventParams = {
        position: { ...this.marker._lngLat },
        marker: this.marker,
        data: this.props.data,
        isHoverStop:false
      };
      this.props.onClick(eventParams);
    }
    event.stopPropagation();
  };

  onMouseHover =(e)=>{
    if (this.props.showOnHoverPopup && this.props.onMouseHover){
    const currentZoom = this.props.map.getZoom();
    const thresholdZoomLevel = this.props.thresholdZoomLevel ?? appConstants.MAP_ZOOM_LEVEL;
   if(currentZoom >= thresholdZoomLevel) {
      const eventParams = {
        position: { ...this.marker._lngLat },
        marker: this.marker,
        data: this.props.data,
        isHoverStop: true
      };
      this.props.onMouseHover(eventParams);
    }    
  }
  }

  onMouseOut=(e)=>{
    if(this.props.showOnHoverPopup && this.props.onMouseHover){
    const currentZoom = this.props.map.getZoom();
    const thresholdZoomLevel = this.props.thresholdZoomLevel ?? 9;
    if (currentZoom >= thresholdZoomLevel) {      
      this.props.onMouseOut();
    }
   }
  }

  onDragStart = (e) => {
    if (this.props.onDragStart) {
      this.props.onDragStart({
        position: { ...this.marker._lngLat },
        marker: this.marker,
        data: this.props.data,
      });
    }
  };

  onDrag = (e) => {
    if (this.props.onDrag) {
      this.props.onDrag({
        position: { ...this.marker._lngLat },
        marker: this.marker,
        data: this.props.data,
      });
    }
  };

  onDragEnd = (e) => {
    if (this.props.onDragEnd) {
      this.props.onDragEnd({
        position: { ...this.marker._lngLat },
        marker: this.marker,
        data: this.props.data,
      });
    }
  };

  render() {
    return (
      <div key={this.props.key}>
        <div
          ref={this.markerRef}
          style={{ zIndex: this.props.zIndex, cursor: "pointer" }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default withMapContext(Marker);
